import {Fragment} from "react";

import { checkForError } from "pstat-anywhere/utils/urls";

export const ErrorCheckWrapper = ({ queryName, children, ...otherProps }) => {
  checkForError(otherProps, queryName);
  return <Fragment>{children}</Fragment>;
};
